const React = require("react");
const { ThemeProvider } = require("@mui/material/styles");
const { default: theme, colorScheme } = require("./src/theme");

/**
 * One theme at the root of both the browser and the SSR render.
 *
 * It has to be here rather than in Layout: /admin/preview/ renders the site's
 * sections without Layout (ADR-0003), and it has to look like the page it is
 * previewing. wrapRootElement is the one seam both renders share, and keeping
 * it in the two Gatsby files together means the server and the browser cannot
 * disagree about which theme they mounted.
 *
 * The mode props are MUI's storage and OS handling: it keeps the reader's
 * choice, which the before-paint script in gatsby-ssr.js reads, and writes the
 * `data-theme` attribute palette.css and theme.ts both key off.
 */
exports.wrapRootElement = ({ element }) =>
  React.createElement(
    ThemeProvider,
    {
      theme,
      defaultMode: colorScheme.defaultMode,
      modeStorageKey: colorScheme.modeStorageKey,
    },
    element,
  );
